<template>
  <div>
    <base-animation
      :type="'success'"
      :text="'Perfeito! Agora divulgue a novidade para seus clientes e aumente o desejo deles!'"
    />
    <base-card>
      <div class="img">
        <div></div>
      </div>
    </base-card>
  </div>
</template>
<script>
import BaseCard from "@/components/Card";
import BaseAnimation from "@/components/Animation";

export default {
  data() {
    return {};
  },
  methods: {
    publishCoupoun() {
      this.$emit("openDrawer", "publishForm");
    },
  },
  components: {
    BaseCard,
    BaseAnimation,
  },
};
</script>
<style scoped>
.img {
  background: #45484d;
  border-radius: 5px;
  width: 100%;
  height: 316px;
  padding: 20px;
  box-shadow: 0px 3px 25px #00000029;
}

.img > div {
  background: #3a3c40;
  width: 100%;
  height: 100%;
  border-radius: 5px;
}
</style>
